// Add your custom JS here.
window.Thermotile || (window.Thermotile = {});
(function ($) {

  /**
	 * jQuery Window Object
	 * 
	 * @var {jQuery} $window
	 * @since 1.0
	 */
	Thermotile.$window = $(window);

	/**
	 * jQuery Body Object
	 * 
	 * @var {jQuery} $body
	 * @since 1.0
	 */
	Thermotile.$body;

  $(window).scroll(function(){
      var w = $(window).scrollTop();
      var d = "translateY(" + w*2.25 + "px)";
      var e = "translateY(" + w/2 + "px)";
      var f = "translateX(" + (-50 + (w*2/20)) + "%)";
    
      //$('.title--anim-right').css({
      //  transform: f
      //});
            
  });

  /**
	 * Thermotile Theme Setup
	 */
	$(window).on('load', function () {
		// Body has been loaded.
		Thermotile.$body = $(document.body).addClass('loaded');
		// Touch is enabled?
		$('html').addClass('ontouchstart' in document ? 'touchable' : 'untouchable');
		Thermotile.initScrollTopButton();
	});
  /**
	 * Get DOM element by id
	 * 
	 * @since 1.0
	 * @param {string} id    ID attribute of element to find
	 * @return {HTMLElement} Matched element
	 */
	Thermotile.byId = function (id) {
		return document.getElementById(id);
	};
  /**
	 * Create a macro task
	 *
	 * @since 1.0
	 * @param {function} fn  Function to handle task.
	 * @param {number} delay Delay time
	 * @return {void}
	 */
	Thermotile.call = function (fn, delay) {
		delay ? setTimeout(fn, delay) : fn();
	}
  /**
	  * Scroll to given target in given duration.
	  *
	  * @since 1.0
	  * @param {mixed}  target   This can be number or string seletor or jQuery object.
	  * @param {number} duration This can be omitted.
	  * @return {void}
	  */

	  Thermotile.scrollTo = function (target, duration) {
	    var _duration = typeof duration == 'undefined' ? 0 : duration;

	    var offset;

	    if (typeof target == 'number') {
	      offset = target;
	    }

	    $('html,body').stop().animate({
	      scrollTop: offset
	    }, _duration);
	  };

   /**
	 * Initialize scroll to top button
	 * 
	 * @since 1.0
	 * @return {void}
	 */
	Thermotile.initScrollTopButton = function () {
		// register scroll top button
		var domScrollTop = Thermotile.byId('scroll-top');
		if (domScrollTop) {
			Thermotile.$body.on('click', '#scroll-top', function (e) {
				Thermotile.scrollTo(0);
				e.preventDefault();
			});

			function _refreshScrollTop() {
				if (window.scrollY > 200) { // issue: heavy js performance, 8.3ms
					domScrollTop.classList.add('show');

					// Show scroll position percent in scroll top button
					var d_height = $(document).height(),
						w_height = $(window).height(),
						c_scroll_pos = $(window).scrollTop();

					var perc = c_scroll_pos / (d_height - w_height) * 214;

					if ($('#progress-indicator').length > 0) {
						$('#progress-indicator').css('stroke-dasharray', perc + ', 400');
					}
				} else {
					domScrollTop.classList.remove('show');
				}
			}

			Thermotile.call(_refreshScrollTop, 500);
			window.addEventListener('scroll', _refreshScrollTop, { passive: true });
		}
	};

  $(document).on('click touch', '.left-sidebar-toggle', function(e) {
    e.preventDefault();
		Thermotile.$body = $('.sidebar-content').addClass('show');
		Thermotile.$body = $('.sidebar-overlay').addClass('show');
		Thermotile.$body = $('.sidebar-close').addClass('show');		
  });
  $(document).on('click touch', '.sidebar-close', function(e) {
    e.preventDefault();
    Thermotile.$body = $('.sidebar-content').removeClass('show');
    Thermotile.$body = $('.sidebar-overlay').removeClass('show');
    Thermotile.$body = $('.sidebar-close').removeClass('show');	
  });
  $(document).on('click touch', '.sidebar-overlay', function(e) {
    e.preventDefault();
		Thermotile.$body = $('.sidebar-content').removeClass('show');
		Thermotile.$body = $('.sidebar-overlay').removeClass('show');
		Thermotile.$body = $('.sidebar-close').removeClass('show');
  });

  // Animation for title/headline scroll left/right 
  if ($('.title--anim').length || $('.grid--gallery').length) {
      $(window).scroll(function () {
          var winHeight = $(window).height(),
              winTop = $(window).scrollTop(),
              winBottom = winTop + winHeight;
          if ($('.title--anim').length) {
              $('.title--anim').each(function () {
                  var height = $(this).height(),
                      toTop = $(this).offset().top,
                      toBottom = toTop + height,
                      toCenter = toTop + (height / 2);
                  if ((toTop <= winBottom) && (toBottom >= winTop)) {
                      if ($(this).hasClass('title--anim-left')) {
                          var titlePos = (100 / winHeight) * (toCenter - winTop);
                      } else {
                          var titlePos = (100 / winHeight) * (winBottom - toCenter);
                      }
                      var finalPos = Math.round(titlePos);
                      $(this).css('transform', 'translateX(' + (finalPos - 50) + '%)');
                  }
              });
          }
          if ($('.grid--gallery').length) {
              $('.grid--gallery').each(function () {
                  var height = $(this).height(),
                      toTop = $(this).offset().top,
                      toBottom = toTop + height,
                      toCenter = toTop + (height / 2);
                  if ((toTop <= winBottom) && (toBottom >= winTop)) {
                      var titlePos = (100 / winHeight) * (toTop - winTop) / 2;
                      var finalPos = Math.round(titlePos);
                      $(this).css('transform', 'translateX(' + (finalPos) + '%)');
                  }
              });
          }
      });
  }
  
if ($('.tiles-grid').length) {
    $('.tiles-grid').each(function () {
        var $grid = $(this);

        // Ensure that Masonry initializes after all images have been loaded
        $grid.imagesLoaded(function () {
            $grid.masonry({
                columnWidth: '.tile-item__sizer',
                gutter: '.tile-item__gutter',
                itemSelector: '.tile-item',
                percentPosition: true,
                stagger: 50,
            });

            // Initialize AOS after Masonry layout is set up
            AOS.init({
                duration: 1000, // Adjust duration as needed
                once: true      // Animations trigger once
            });
        });
    });
}


// Navigation
if (window.matchMedia('(min-width: 992px)').matches) {
  if($('#navbarNavDropdown').length) {
      new SimpleBar(document.getElementById('navbarNavDropdown'));
  }
  $('.navbar-nav').removeClass('submenu');
  $('.reset-submenu').parent().removeClass('show');
  $('.nav-link').each( function(){
    $(this).addClass('show');
    $(this).parent().removeClass('open');
  });
  $('.dropdown-menu').each( function(){
    $(this).addClass('show');
  });
}
if (window.matchMedia('(max-width: 991px)').matches) {
  $('.dropdown-menu').wrap("<div class='nav-sub'></div>");
  $('.nav-link').each( function(){
    $(this).removeClass('show');
  });
  $('.dropdown-menu').each( function(){
    $(this).removeClass('show');
  });
  $('.nav-sub').each((index, element) => new SimpleBar(element));
}

$(document).on('click touch', '.reset-submenu', function(e) {
  e.preventDefault();
  e.stopPropagation(e);
  $('.nav-link').each( function(){
    $(this).removeClass('show');
    $(this).parent().removeClass('open');
  });
  $('.dropdown-menu').each( function(){
    $(this).removeClass('show');
  });
  $('.navbar-nav').removeClass('submenu');
  $(this).removeClass('show');
  $('.navigation .sidenav').find('.icon-link').parent().removeClass('active');
});



// Navigation mobile
if (window.matchMedia('(max-width: 991px)').matches) {

    $(document).on('click touch', '.dropdown .nav-link', function(e) {
      e.preventDefault();
      e.stopPropagation(e);
      $('.nav-link').each( function(){
        if ($(this).hasClass('show')){
          $(this).removeClass('show');
        }
        if ($(this).parent().hasClass('open')){
          $(this).parent().removeClass('open');
        }    
      });
      $('.dropdown-menu').each( function(){
        if ($(this).hasClass('show')){
          $(this).removeClass('show');
        }
      });
      if ($('.navbar-nav').hasClass('submenu')){
        $(this).removeClass('submenu');
      }
      if ($('.reset-submenu').hasClass('submenu')){
        $(this).removeClass('show');
      } 
      if (window.matchMedia('(max-width: 991px)').matches){
        $(this).addClass('show');
        $('.reset-submenu').addClass('show');
        $('.navbar-nav').addClass('submenu');
        $(this).parent().addClass('open');
        $('.navigation .sidenav').find('.icon-link').parent().removeClass('active');
      }
      var section = $(this).attr('title');
      $('.navigation .sidenav').find('.icon-link[data-nav="' + section + '"]').parent().addClass('active');
    });

    $(document).on('click touch', '.navigation .sidenav .icon-link', function (e) {
        e.preventDefault(e);
        var section = $(this).data('nav');
        if (!$(this).hasClass('active')) {
            $('.navigation .sidenav').find('.icon-link').parent().removeClass('active');
            $('.navigation .navbar-nav').find('.nav-link[title="' + section + '"]').trigger('click');
        }
    });
}

$(document).on('click touch', '.navigation .nav-link', function(e){
  if(! $(this).parent().hasClass('dropdown')) {
    e.preventDefault(e);
    e.stopPropagation(e);
    var target = $(this).attr('href');
    window.location = target;
  }
});

})(jQuery);

AOS.init();
const swiper = new Swiper(".homepage-swiper", {
    speed: 3000,
    effect: "fade",
    fadeEffect: {
        crossFade: true
    },
    slidesPerView: 1,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    autoplay: {
        enabled: false,
        delay: 6000,
    },
    loop: false,
    pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
    },

});


const swiper2 = new Swiper(".cladding-swiper", {
    speed: 3000,
    effect: "fade",
    fadeEffect: {
        crossFade: true
    },
    slidesPerView: 1,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    autoplay: {
        delay: 5000,
    },
    loop: true,
    pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
    },

});


const swiper1 = new Swiper(".brands-slider", {
	slidesPerView: 1,
  spaceBetween: 30,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true,
	},
	loop: false,
  breakpoints: {
		576: {
			slidesPerView: 1,
		},
		768: {
			slidesPerView: 2,
		},
		992: {
			slidesPerView: 3,
		},
	},
});

document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.brand-slider', { // Unique selector
        slidesPerView: 3,
        spaceBetween: 10,
        loop: true,
        autoplay: {
            delay: 3000,
                disableOnInteraction: false,
            },      
        breakpoints: {
            576: {
                slidesPerView: 4,
                spaceBetween: 15,
            },
            768: {
                slidesPerView: 5,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 6,
                spaceBetween: 30,
            },
        },
    });
    new Swiper('.products-brand-slider', {
        slidesPerView: 3,
        spaceBetween: 10,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        breakpoints: {
            576: {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            768: {
                slidesPerView: 4, // Max set to 4
                spaceBetween: 20,
            },
        },
    });                                                     
});


document.addEventListener('DOMContentLoaded', function () {
    let youtubePlayers = [];
    let vimeoPlayers = [];

    // Pause all videos function
    function pauseAllVideos() {
        youtubePlayers.forEach(player => player.pauseVideo());
        vimeoPlayers.forEach(player => player.pause());
    }

    // Initialize Swiper
    const swiper = new Swiper('.single-product-slider', {
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            slideChange: pauseAllVideos,  // Call pauseAllVideos on slide change
        },
    });

    // Initialize YouTube players
    function initializeYouTubePlayers() {
        document.querySelectorAll('.video-container[data-type="youtube"]').forEach(container => {
            if (!container.__ytPlayer) {
                const videoId = new URL(container.dataset.url).searchParams.get('v');
                const player = new YT.Player(container, {
                    height: '360',
                    width: '640',
                    videoId: videoId,
                });
                container.__ytPlayer = player;
                youtubePlayers.push(player);
            }
        });
    }

    // Initialize Vimeo players
    function initializeVimeoPlayers() {
        document.querySelectorAll('.video-container[data-type="vimeo"]').forEach(container => {
            if (!container.__vimeoPlayer) {
                const player = new Vimeo.Player(container, {
                    url: container.dataset.url,
                    width: 640,
                });
                container.__vimeoPlayer = player;
                vimeoPlayers.push(player);
            }
        });
    }

    // Initialize YouTube and Vimeo API
    function onYouTubeIframeAPIReady() {
        initializeYouTubePlayers();
    }

    function onVimeoAPIReady() {
        initializeVimeoPlayers();
    }

    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
    window.onVimeoAPIReady = onVimeoAPIReady;

    // Intersection Observer setup for pausing videos when slides are not visible
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                pauseAllVideos();  // Pause videos when slide is not in view
            }
        });
    }, { threshold: 0.5 });

    document.querySelectorAll('.swiper-slide').forEach(slide => {
        observer.observe(slide);
    });

    // Ensure players are initialized on page load
    onYouTubeIframeAPIReady();
    onVimeoAPIReady();
});


// Look for .hamburger
var hamburger = document.querySelector(".hamburger");
var headerLogo = document.getElementById("headerLogoStart");
var navbar = document.getElementById('navigation');
// On click
hamburger.addEventListener("click", function() {
// Toggle class "is-active"
document.getElementsByTagName('html')[0].classList.toggle("overflow");
hamburger.classList.toggle("is-active");
navbar.classList.toggle("open");
headerLogo.classList.toggle("start");
// Do something else, like open/close menu
});

const body = document.body;
const nav = document.querySelector(".site header");
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
let lastScroll = 10;

function scrollDist() {
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 10) {
        body.classList.remove(scrollUp);
        return;
    }

    if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
        // down
        body.classList.remove(scrollUp);
        body.classList.add(scrollDown);
    } else if (
        currentScroll < lastScroll &&
        body.classList.contains(scrollDown)
    ) {
        // up
        body.classList.remove(scrollDown);
        body.classList.add(scrollUp);
    }
    lastScroll = currentScroll;
}

window.addEventListener("scroll", scrollDist );

window.addEventListener("load", scrollDist );



function accordionBuild(el) {
  el.classList.add('js-accordion');
  el.setAttribute('id', 'accordionGroup');
  el.setAttribute('role', 'presentation');
  Array.from(el.querySelectorAll('.nav-multi-col__column')).forEach(function (column) {
    const panel = column.querySelector('.nav-multi-col__panel');
    panel.classList.add('hidden');
    panel.classList.add('js-accordion-panel');
    const title = column.querySelector('.nav-multi-col__heading');
    title.parentElement.classList.add('js-accordion-trigger');
    title.classList.add('js-accordion-title');
  });
}

function accordionDestroy(el) {
  el.classList.remove('js-accordion');
  el.removeAttribute('id');
  el.removeAttribute('role');
  Array.from(el.querySelectorAll('.nav-multi-col__column')).forEach(function (column) {
    const panel = column.querySelector('.nav-multi-col__panel');
    panel.classList.remove('hidden');
    panel.classList.remove('js-accordion-panel');
    const title = column.querySelector('.nav-multi-col__heading');
    title.parentElement.classList.remove('js-accordion-trigger');
    title.classList.remove('js-accordion-title');
  });
}

function toggleAccordion() {
  const accordion = document.querySelector('.nav-multi-col');
  if (window.matchMedia("(max-width: 768px)").matches) {
    accordionBuild(accordion);
    accordion.addEventListener('click', handleAccordionClick);
  } else {
    accordionDestroy(accordion);
    accordion.removeEventListener('click', handleAccordionClick);
  }
}

function handleAccordionClick(event) {
  const target = event.target.closest('.js-accordion-trigger');
  if (!target) return;

  const isExpanded = target.getAttribute('aria-expanded') === 'true';
  const panel = document.getElementById(target.getAttribute('aria-controls'));

  if (isExpanded) {
    target.setAttribute('aria-expanded', 'false');
    panel.classList.add('hidden');
    target.querySelector('.lni').classList.replace('w-icon-angle-up', 'w-icon-angle-down');
  } else {
    target.setAttribute('aria-expanded', 'true');
    panel.classList.remove('hidden');
    target.querySelector('.lni').classList.replace('w-icon-angle-down', 'w-icon-angle-up');
  }

  event.preventDefault();
}

// Initialize on load and on resize
window.addEventListener('load', toggleAccordion);
window.addEventListener('resize', toggleAccordion);



(function($) {
	//"use strict";
	//$(function() {

		//-----------------------------------------------------
		// [2] Ajax load products - On Click
		//-----------------------------------------------------
		//$('#pp_loadmore_products').click(function(){

		//	var button = $(this),
		//	    data = {
		//		'action': 'loadmore',
		//		'query': wp_js_vars.posts, // that's how we get params from wp_localize_script() function
		//		'page' : wp_js_vars.current_page
		//	};

		//	$.ajax({
		//		url : wp_js_vars.ajaxurl, // AJAX handler
		//		data : data,
		//		related_products : 'no',
		//		type : 'POST',
		//		beforeSend : function ( xhr ) {
		//			button.addClass('loading');
		//			button.text('LOADING ...'); // change the button text, you can also add a preloader image
		//		},
		//		success : function( data ){
		//			if( data ) {
		//				//console.log('current_page: ' + wp_js_vars.current_page + ' max_page: ' + wp_js_vars.max_page);
		//				$('.products__grid').append( data ); // where to insert posts
		//				button.removeClass('loading');
		//				button.text( 'Load more' );
		//				wp_js_vars.current_page++;

		//				if ( wp_js_vars.current_page == wp_js_vars.max_page )
		//					button.remove(); // if last page, remove the button
		//			} else {
		//				button.remove(); // if no data, remove the button as well
		//			}
		//		}
		//	});
	//	});

	//});
  

$('.refil__left').magnificPopup({   
   //disableOn: 700, 
   type: 'iframe', 
   mainClass: 'mfp-fade', 
   removalDelay: 160, 
   preloader: false, 
   fixedContentPos: false,  
   gallery: {
  enabled: true, // set to true to enable gallery
  preload: [1,3], // read about this option in next Lazy-loading section
  navigateByImgClick: true,
  arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button
  tPrev: 'Previous (Left arrow key)', // title for left button
  tNext: 'Next (Right arrow key)', // title for right button
  tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
  },
  iframe: {
		markup: '<div class="mfp-iframe-scaler">' +
			'<div class="mfp-close"></div>' +
			'<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
			'</div>',
		patterns: {
			youtube: {
				index: 'youtube.com/',
				id: 'v=',
				src: 'https://www.youtube.com/embed/%id%?autoplay=1'
			}
		}
	}
});

$(document).on('click touch', '.product-video__play-button', function(e) {
    e.preventDefault();
    $('[data-youtube]').youtube_background();
    Thermotile.$body = $('.js-productFullVideo').addClass('video--started'); 
  });
$(document).on('click touch', '.video--started', function(e) {
    e.preventDefault();
  });

if ($('.product__container').length) {
  $('.product__colors-field').on('click', function (e) {
      e.preventDefault();
      if (!$(this).hasClass('active')) {
          $('.product__colors .product__colors-field').removeClass('active');
          $(this).addClass('active');
          var color = $(this).data('color');
          $('.product__image .product__image--color').removeClass('active');
          $('.product__image .product__image--color').each(function () {
              if ($(this).attr('data-color') == color) {
                  $(this).addClass('active');
              }
          });
      }
  });
  if ($('.product__features').length) {
    $('.toggle-features').on('click', function (e) {
        e.preventDefault();
        var feature = $(this).data('feature');
        $('.product__features--feature').fadeOut();
        $('.product__features--feature[data-feature="'+feature+'"]').fadeIn();
        $(this).slideUp();
        $('.toggle-features[data-feature!="'+feature+'"]').slideDown();

    });
    $('.product__feature .toggle-details').on('click', function (e) {
        e.preventDefault();
        var details = $(this).parents('.product__feature').children('.product__feature-detail');
        if(details.hasClass('show')) {
            details.removeClass('show');
        } else {
            $('.product__feature-detail').removeClass('show');
            details.addClass('show');
            if(details.find('.video').length) {
                const video = new Plyr(details.find('.video'), {
                    controls: ['play-large', 'fullscreen'],
                    volume: 0,
                    muted: true,
                });
                video.play();
            }
        }
    });
  }
}

// Video Plyr
if ($('.video-player').length) {
    $('.video-player').each(function () {
        let ctrlsPlayer = ['play-large'];
        if ($(this).attr('controls')) {
            ctrlsPlayer.push('play', 'progress');
        }
        ctrlsPlayer.push('mute', 'volume');
        if ($(this).attr('controls')) {
            ctrlsPlayer.push('settings');
        }
        ctrlsPlayer.push('fullscreen');
        const player = new Plyr($(this), {
            controls: ctrlsPlayer,
        });
        if ($(this).hasClass('play')) {
            player.play();
        }

    });
}

if ($('.start-slider').length) {
    let startSlider = new Swiper('.start-slider', {
        speed: 600,
        effect: 'fade',
        loop: false,
        lazy: true,
        autoplay: {
            delay: 9000,
        },
        keyboard: {
            enabled: true,
        },
        navigation: {
            nextEl: '.start-slider .swiper-button-next',
            prevEl: '.start-slider .swiper-button-prev',
        },
        pagination: {
            el: '.start-slider .swiper-pagination',
            clickable: true,
        },
    });
}

document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.swiper-container', {
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});

$(document).on('facetwp-loaded', function() {
  $('.facetwp-facet').each(function() {
    var facet = $(this);
    var facet_name = facet.attr('data-name');
    var facet_type = facet.attr('data-type');
    var facet_label = FWP.settings.labels[facet_name];
    if (facet_type !== 'pager' && facet_type !== 'sort' && facet_type !== 'reset' && facet_type !== 'search') {
      if (facet.closest('.facet-wrap').length < 1 && facet.closest('.facetwp-flyout').length < 1) {
        facet.wrap('<div class="facet-wrap"></div>');
        facet.before('<h4 class="facet-label" style="display:none;">' + facet_label + '</h4>');
        facet.wrap('<div class="facet-wrapper facet-wrapper-' + facet_name + '" data-for="' + facet_name + '></div>');
        facet.before('<a class="facet-collapse-link collapsed" data-for="' + facet_name + '" data-bs-toggle="collapse" href="#collapse_facet_' + facet_name + '" role="button" aria-expanded="false" aria-controls="collapse_facet_' + facet_name + '"><p class="h4 facet-label" data-for="' + facet_name + '">' + facet_label + ' <i class="w-icon-angle-down" aria-hidden="true"></i></p></a>');
        facet.wrap('<div class="collapse facet-collapse" data-for="' + facet_name + '" id="collapse_facet_' + facet_name + '"></div>');
      }
    }
  });
});
document.addEventListener('facetwp-loaded', function() {
  $.each(FWP.settings.num_choices, function(key, val) {

    // assuming each facet is wrapped within a "facet-wrap" container element
    // this may need to change depending on your setup, for example:
    // change ".facet-wrap" to ".widget" if using WP text widgets

    var $facet = $('.facetwp-facet-' + key);
    var $wrap = $facet.closest('.facet-wrap');
    var $flyout = $facet.closest('.flyout-row');
    if ($wrap.length || $flyout.length) {
      var $which = $wrap.length ? $wrap : $flyout;
      (0 === val) ? $which.hide() : $which.show();
    }
  });
});

$(document).on('facetwp-loaded', function(){
  if ($('.facetwp-checkbox').hasClass('checked')){
    $('.facetwp-checkbox.checked').closest('.facet-wrap').find('.facet-collapse-link').removeClass('collapsed');
    $('.facetwp-checkbox.checked').closest('.facet-collapse').addClass('show');
  }
});
$(document).on('facetwp-loaded', function(){
  if ($('.sidebar-content').hasClass('show')){
    $('.sidebar-close').trigger('click');
  }
});



$(document).on('facetwp-refresh', function() {
  if (FWP.loaded) {
    $('.loader-container').css('display', 'block');
  }
});

$(document).on('facetwp-loaded', function() {
  $('.loader-container').css('display', 'none');
});




$(function() 
{
	$.each($('.overflowToggler'), function (index, item)
	{
		overflowTogglerInitialize($(item));
	});
	
	jQuery.fn.extend(
	{
		overflowToggler: function() 
		{
			if(this == null)
				return;
			
			if(this.length == 1)
				overflowTogglerInitialize(this);
			else
			{
				var length = this.length;
				for(var i = 0; i < length; i++)
				{
					overflowTogglerInitialize($(this[i]));
				}
			}
		}
	});
});

function overflowTogglerInitialize(item)
{
	//handles situations where there was previously no overflow, but now there is overflow
	function handleNewOverflow(item)
	{
		var container = $("<div>").addClass("overflowToggler-container");
		
		item.before(container);
		container.append(item);
		
		var toggle = $("<div>").addClass("overflowToggler-toggler").addClass("closed");
		var toggleIcon = $("<div>").text("Show more").addClass("overflowToggler-toggleIcon");

		item.parent().append($("<div>").addClass("overflowToggler-contentSpacer"));

		toggle.append(toggleIcon);
		item.parent().append(toggle);
		item.parent().addClass("closed");

		toggle.click(function ()
		{
			$(this).toggleClass("open closed");
			$(this).parent().toggleClass("open closed");
		});
	}
	
	//if the item hasn't been initialized yet
	if(item.hasClass('overflowToggler') || !item.hasClass("overflowToggler-content"))
	{
		item.removeClass('overflowToggler');
		item.addClass("overflowToggler-content");
		
		//if there's overflow
		if (hasVerticalOverflow(item[0]))
			handleNewOverflow(item);
	}
	else	//already initialized
	{
		var container = item.parent();
		var toggler = container.find("> .overflowToggler-toggler");
		
		//if there wasn't overflow last time it was initialized
		if(toggler == null || toggler.length == 0)
			handleNewOverflow(item);
		else //there was overflow last time it was initialized
		{
			//close it if it was open
			if(toggler.hasClass("open"))
			{
				toggler.toggleClass("open closed");
				toggler.parent().toggleClass("open closed");
			}
			
			//if there's no overflow now
			if (!hasVerticalOverflow(item[0]))
			{
				container.after(item);
				container.remove();
			}
		}
	}
}

function hasVerticalOverflow(element)
{
	return element.scrollHeight > element.clientHeight;
}



}(jQuery));

            

var sticky_sidebar = function($){
  var stc = document.getElementById('left-sidebar');
  if (stc !== null) {
    var sidebar = new StickySidebar('.sticky-content', {
      topSpacing: 80,
      bottomSpacing: 60,
      containerSelector: '.widget-area',
      minWidth: 992,
      resizeSensor: true,
    });
  }
};

jQuery(document).ajaxComplete(function() {
  // Ensure $ is defined inside the callback
  var $ = jQuery;
  sticky_sidebar($);
});

jQuery(document).ready(function($) {
  sticky_sidebar($);
});


// FacetWP AJAX Refresh (Recommended for FacetWP AJAX)
jQuery(document).on('facetwp-loaded', function() {
    sticky_sidebar(jQuery);
});
